import { render, staticRenderFns } from "./BannerSimple.vue?vue&type=template&id=215e9ed4&"
import script from "./BannerSimple.vue?vue&type=script&lang=js&"
export * from "./BannerSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports